<ng-hbm-bdi-loader *ngIf="isLoading"></ng-hbm-bdi-loader>

<div class="container">
    <div class="row justify-content-center text-center mt-3">
        <!-- Kitchen -->
        <figure *ngIf="!isLoading && (customer.initContext === CONTEXT.KITCHEN  || !customer.initContext)" class="configurator-menu">
            <img src="assets/img/home/kitchen.jpg?v=2" alt="Brico Depot 3D" />
            <figcaption>
                <span class="configurator-description">
                    <p [innerHtml]="'homepage.textKitchen' | translate"></p>
                    <p [innerHtml]="'homepage.textKitchen2' | translate"></p>
                </span>        
                <span class="d-block mt-4 configurator-buttons">
                    <ng-hbm-bdi-btn class="primary mb-2" (click)="startNewProject(CONTEXT.KITCHEN)" [label]="'homepage.cta' | translate"></ng-hbm-bdi-btn>
                    <ng-hbm-bdi-btn *ngIf="isProjectButtonVisible()" class="transparent" (click)="goProjects(CONTEXT.KITCHEN)" [label]="'homepage.link' | translate"></ng-hbm-bdi-btn>
                </span>
                <span class="retrieve-project">
                    <label class="bt-text" (click)="retrieveProject()" [routerLink]="['/kitchen/configuration']">{{ "need_mapping.retrieve_project" | translate }}</label>
                </span>
            </figcaption>
        </figure>

        <!-- Storage -->
        <figure *ngIf="!isLoading && (customer.initContext === CONTEXT.STORAGE || !customer.initContext)" class="configurator-menu">
            <img src="assets/img/home/storage.jpg?v=2" alt="Brico Depot 3D" />
            <figcaption>
                <span class="configurator-description">
                    <p [innerHtml]="'homepage.textStorage' | translate"></p>
                </span>        
                <span class="d-block mt-4 configurator-buttons">
                    <ng-hbm-bdi-btn class="primary mb-2" (click)="startNewProject(CONTEXT.STORAGE)" [label]="'homepage.cta' | translate"></ng-hbm-bdi-btn>
                    <ng-hbm-bdi-btn *ngIf="isProjectButtonVisible()" class="transparent" (click)="goProjects(CONTEXT.STORAGE)" [label]="'homepage.link' | translate"></ng-hbm-bdi-btn>
                </span>
            </figcaption>
        </figure>

        <!-- Bathroom -->
        <figure *ngIf="!isLoading && (customer.initContext === CONTEXT.BATHROOM  || !customer.initContext)" class="configurator-menu">
            <img src="assets/img/home/bathroom.jpg?v=2" alt="Brico Depot 3D" />
            <figcaption>
                <span class="configurator-description">
                    <p [innerHtml]="'homepage.textBathroom' | translate"></p>
                    <p [innerHtml]="'homepage.textBathroom2' | translate"></p>
                </span>        
                <span class="d-block mt-4 configurator-buttons">
                    <ng-hbm-bdi-btn class="primary mb-2" (click)="startNewProject(CONTEXT.BATHROOM)" [label]="'homepage.cta' | translate"></ng-hbm-bdi-btn>
                    <ng-hbm-bdi-btn *ngIf="isProjectButtonVisible()" class="transparent" (click)="goProjects(CONTEXT.BATHROOM)" [label]="'homepage.link' | translate"></ng-hbm-bdi-btn>
                </span>
            </figcaption>
        </figure>
    </div>
</div>

